import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/megaphone_icon.png'
import _imports_1 from '@/assets/arrow_right_gray.png'
import _imports_2 from '@/assets/info_icon.png'
import _imports_3 from '@/assets/fi-rr-cross-small.png'
import _imports_4 from '@/assets/shop_icon.png'
import _imports_5 from '@/assets/plane_icon.png'
import _imports_6 from '@/assets/tip_guide_icon.png'
import _imports_7 from '@/assets/refund_history_icon.png'


const _withScopeId = n => (_pushScopeId("data-v-804ba680"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "container",
  style: {"position":"relative"}
}
const _hoisted_2 = { class: "main-wrap" }
const _hoisted_3 = { class: "content-wrap" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tax-refund-guide__icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "guide icon"
  })
], -1))
const _hoisted_5 = { class: "tax-refund-guide__text" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tax-refund-guide__arrow" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "move to guide page"
  })
], -1))
const _hoisted_7 = { class: "greeting" }
const _hoisted_8 = { class: "greeting__sub" }
const _hoisted_9 = { class: "greeting__main" }
const _hoisted_10 = { class: "greeting__title" }
const _hoisted_11 = { class: "greeting__title--text" }
const _hoisted_12 = { class: "greeting__info" }
const _hoisted_13 = { class: "guide-popup" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "guide-popup__tail" }, null, -1))
const _hoisted_15 = { class: "guide-popup__bubble" }
const _hoisted_16 = { class: "guide-popup__close-btn" }
const _hoisted_17 = { class: "guide-popup__content" }
const _hoisted_18 = { class: "guide-popup__section" }
const _hoisted_19 = { class: "guide-popup__title" }
const _hoisted_20 = { class: "guide-popup__description" }
const _hoisted_21 = { class: "guide-popup__section" }
const _hoisted_22 = { class: "guide-popup__title" }
const _hoisted_23 = { class: "guide-popup__description" }
const _hoisted_24 = { class: "guide-popup__description" }
const _hoisted_25 = { class: "service-wrap" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "service__icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    alt: "register refund way"
  })
], -1))
const _hoisted_27 = { class: "service__content" }
const _hoisted_28 = { class: "service__title" }
const _hoisted_29 = { class: "service__description" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "service__icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_5,
    alt: "out request"
  })
], -1))
const _hoisted_31 = { class: "service__content" }
const _hoisted_32 = { class: "service__title" }
const _hoisted_33 = { class: "service__description" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "service-guide__icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_6,
    alt: "service guide"
  })
], -1))
const _hoisted_35 = { class: "service-guide__content" }
const _hoisted_36 = { class: "service-guide__title" }
const _hoisted_37 = { class: "service-guide__description" }
const _hoisted_38 = { class: "service-guide__description--text" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "service guide"
}, null, -1))
const _hoisted_40 = { class: "refund-history" }
const _hoisted_41 = { class: "refund-history__label" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card__icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_7,
    alt: "refund-history"
  })
], -1))
const _hoisted_43 = { class: "card__content" }
const _hoisted_44 = { class: "refund-history__title" }
const _hoisted_45 = { class: "refund-history__subtitle" }
const _hoisted_46 = { class: "bs" }
const _hoisted_47 = { class: "bs__header" }
const _hoisted_48 = { class: "bs__header--title" }
const _hoisted_49 = { class: "bs__content" }
const _hoisted_50 = { class: "bs__content--description" }
const _hoisted_51 = { class: "bs__description bs__description--primary" }
const _hoisted_52 = { class: "bs__description" }
const _hoisted_53 = { class: "bs__actions" }
const _hoisted_54 = { class: "bs" }
const _hoisted_55 = { class: "bs__header" }
const _hoisted_56 = { class: "bs__header--title" }
const _hoisted_57 = { class: "bs__content" }
const _hoisted_58 = { class: "bs__content--description" }
const _hoisted_59 = { class: "bs__description bs__description--primary" }
const _hoisted_60 = { class: "bs__actions" }
const _hoisted_61 = { class: "bs" }
const _hoisted_62 = { class: "bs__header" }
const _hoisted_63 = { class: "bs__header--title" }
const _hoisted_64 = { class: "bs__content" }
const _hoisted_65 = { class: "bs__content--description" }
const _hoisted_66 = { class: "bs__description bs__description--primary" }
const _hoisted_67 = { class: "bs__actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainAdsSwiper = _resolveComponent("MainAdsSwiper")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "tax-refund-guide",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.goToTaxRefundGuide && $setup.goToTaxRefundGuide(...args)))
        }, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('main_guide_1')), 1),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('main_greeting_1')), 1),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('main_greeting_2')), 1)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("img", {
                class: "greeting__info--icon",
                src: _imports_2,
                alt: "Info Icon",
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.isGuidePopupOpen = true))
              }),
              _createElementVNode("div", {
                class: _normalizeClass(['guide-popup-wrap', { 'guide-popup-wrap--hidden': !$setup.isGuidePopupOpen }])
              }, [
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("img", {
                        src: _imports_3,
                        alt: "guide-popup-close-btn",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.isGuidePopupOpen = false))
                      })
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('main_guide_popup_title_1')), 1),
                        _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.$t('main_guide_popup_description_1')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('main_guide_popup_title_2')), 1),
                        _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.$t('main_guide_popup_description_2_1')), 1),
                        _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.$t('main_guide_popup_description_2_2')), 1)
                      ])
                    ])
                  ])
                ])
              ], 2)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", {
            class: "card card__service",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.goToRemitBook && $setup.goToRemitBook(...args)))
          }, [
            _hoisted_26,
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$t('main_remit_book_title')), 1),
              _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.$t('main_remit_book_description')), 1)
            ])
          ]),
          _createElementVNode("div", {
            class: "card card__service",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.goToOutRequest && $setup.goToOutRequest(...args)))
          }, [
            _hoisted_30,
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.$t('main_out_title')), 1),
              _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.$t('main_out_description')), 1)
            ])
          ])
        ]),
        _createElementVNode("div", {
          class: "service-guide",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.goToTips && $setup.goToTips(...args)))
        }, [
          _hoisted_34,
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.$t('main_guide_2_1')), 1),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.$t('main_guide_2_2')), 1),
              _hoisted_39
            ])
          ])
        ]),
        _createVNode(_component_MainAdsSwiper),
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.$t('main_refund_history_3')), 1),
          _createElementVNode("div", {
            class: "refund-history__card card",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => ($setup.goToRefundHistory && $setup.goToRefundHistory(...args)))
          }, [
            _hoisted_42,
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.$t('main_refund_history_1')), 1),
              _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.$t('main_refund_history_2')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Modal, {
      isModalOpen: $setup.isReusePassportModalOpen,
      type: "bottom-sheet",
      "close-modal": () => $setup.isReusePassportModalOpen = false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("div", _hoisted_48, _toDisplayString($setup.loadedPassportName), 1)
          ]),
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("p", _hoisted_51, _toDisplayString(_ctx.$t('dialog_load_passport_description_1')), 1),
              _createElementVNode("p", _hoisted_52, _toDisplayString(_ctx.$t('dialog_load_passport_description_2')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("div", {
              class: "primary-btn",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => ($setup.startServiceWithSavedData && $setup.startServiceWithSavedData(...args)))
            }, _toDisplayString(_ctx.$t('dialog_load_passport_confirm')), 1),
            _createElementVNode("div", {
              class: "primary-text-btn",
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => ($setup.onClickResetPassport && $setup.onClickResetPassport(...args)))
            }, _toDisplayString(_ctx.$t('dialog_load_passport_cancel')), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["isModalOpen", "close-modal"]),
    _createVNode(_component_Modal, {
      isModalOpen: $setup.isResetPassportModalOpen,
      type: "bottom-sheet",
      "close-modal": () => $setup.isResetPassportModalOpen = false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_54, [
          _createElementVNode("div", _hoisted_55, [
            _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.$t('dialog_overwrite_passport_title_1')), 1)
          ]),
          _createElementVNode("div", _hoisted_57, [
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("p", _hoisted_59, _toDisplayString(_ctx.$t('dialog_overwrite_passport_description_1')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_60, [
            _createElementVNode("div", {
              class: "primary-btn",
              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => ($setup.startServiceWithoutSavedData && $setup.startServiceWithoutSavedData(...args)))
            }, _toDisplayString(_ctx.$t('confirm')), 1),
            _createElementVNode("div", {
              class: "primary-text-btn",
              onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.isResetPassportModalOpen = false))
            }, _toDisplayString(_ctx.$t('cancel')), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["isModalOpen", "close-modal"]),
    _createVNode(_component_Modal, {
      isModalOpen: $setup.isCustomsValidationProcessModalOpen,
      type: "bottom-sheet",
      "close-modal": () => $setup.isCustomsValidationProcessModalOpen = false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_61, [
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("div", _hoisted_63, _toDisplayString(_ctx.$t('main_remit_alert_title')), 1)
          ]),
          _createElementVNode("div", _hoisted_64, [
            _createElementVNode("div", _hoisted_65, [
              _createElementVNode("p", _hoisted_66, _toDisplayString(_ctx.$t('main_remit_alert_description')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_67, [
            _createElementVNode("div", {
              class: "primary-btn",
              onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => ($setup.goToOutRequest && $setup.goToOutRequest(...args)))
            }, _toDisplayString(_ctx.$t('confirm')), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["isModalOpen", "close-modal"]),
    _createVNode(_component_Footer)
  ]))
}